import { ArrowDown, Check, Plus } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Icon } from "@/advisor/icons";
import { useAdvisor } from "@/advisor/AdvisorContext";
import { DemoRenderer } from "@/advisor/demos/DemoRenderer";
import { Disclaimer } from "@/advisor/Disclaimer";

export const HowItWorksModal = ({ sol, onClose, showAdd = true }) => {
  const { state, toggleSelect } = useAdvisor();
  if (!sol) return null;
  const added = state.selected.includes(sol.slug);

  return (
    <Dialog open={!!sol} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg max-h-[92vh] overflow-y-auto bg-[#151513] text-[#F3EEE4] border-white/10 p-5 sm:p-6" data-testid="modal-how-it-works">
        <DialogHeader className="text-left">
          <div className="flex items-center gap-3">
            <span className="h-11 w-11 rounded-xl bg-[#D6AD62]/15 text-[#F3D592] grid place-items-center">
              <Icon name={sol.icon} className="h-5 w-5" />
            </span>
            <DialogTitle className="text-xl font-display">{sol.name} necə işləyir?</DialogTitle>
          </div>
          <DialogDescription className="text-[#a9a398] pt-2">{sol.long_desc || sol.short_desc}</DialogDescription>
        </DialogHeader>

        <ol className="mt-2" data-testid="how-it-works-steps">
          {sol.steps.map((st, i) => (
            <li key={i} className="flex flex-col items-start">
              <div className="flex items-center gap-3 w-full rounded-xl bg-white/[0.03] border border-white/[0.06] p-3">
                <span className="h-7 w-7 shrink-0 rounded-full bg-[#D6AD62] text-[#111110] font-bold text-sm grid place-items-center font-mono">{i + 1}</span>
                <span className="text-sm text-[#E9E3D8]">{st}</span>
              </div>
              {i < sol.steps.length - 1 && <ArrowDown className="h-4 w-4 text-[#5c5850] ml-4 my-1" />}
            </li>
          ))}
        </ol>

        {sol.has_demo && sol.demo_type && (
          <div className="mt-5">
            <div className="adv-eyebrow mb-3">Mini demo</div>
            <DemoRenderer type={sol.demo_type} businessKey={state.business?.key} />
          </div>
        )}

        <div className="mt-4">
          <Disclaimer text="Bu yalnız funksiyanın nümunəsidir. Layihənizin dizaynı fərdi hazırlanacaq." />
        </div>

        {showAdd && (
          <button
            className={`adv-btn-base w-full mt-4 ${added ? "bg-[#D6AD62]/15 text-[#F3D592] border border-[#D6AD62]/50" : "bg-[#D6AD62] text-[#111110]"}`}
            onClick={() => toggleSelect(sol.slug)}
            data-testid="modal-add-to-project"
          >
            {added ? <><Check className="h-4 w-4" /> Layihəyə əlavə edildi</> : <><Plus className="h-4 w-4" /> Layihəmə əlavə et</>}
          </button>
        )}
      </DialogContent>
    </Dialog>
  );
};
